var _defineProperty = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _require = require('./consts'),
  CANADA_REGIONS = _require.CANADA_REGIONS;
var envConfigs = {
  dev: require("./environment/dev/runtimeProfiles/shared.js"),
  test: require("./environment/test/runtimeProfiles/shared.js"),
  cert: require("./environment/cert/runtimeProfiles/shared.js"),
  internalprod: require("./environment/internalprod/runtimeProfiles/shared.js"),
  prod: require("./environment/prod/runtimeProfiles/shared.js")
};
var Buildtime = /*#__PURE__*/function () {
  "use strict";

  function Buildtime(_ref) {
    var device = _ref.device,
      env = _ref.env,
      brand = _ref.brand,
      _ref$override = _ref.override,
      override = _ref$override === void 0 ? {} : _ref$override,
      _ref$domainOverride = _ref.domainOverride,
      domainOverride = _ref$domainOverride === void 0 ? '' : _ref$domainOverride;
    _classCallCheck(this, Buildtime);
    if (Buildtime.instance) {
      return Buildtime.instance;
    }
    Buildtime.instance = this;
    this.device = device;
    this.env = env;
    this.brand = brand;
    this.override = override;
    this.domainOverride = domainOverride;
    return this;
  }
  _createClass(Buildtime, [{
    key: "profile",
    value: function profile() {
      if (!this.env || !this.device || !this.brand) {
        return new Error('Environment or Device or Brand not specified');
      }
      try {
        var envPath = "./environment/".concat(this.env);
        var buildtimeProfile = require("".concat(envPath, "/buildtimeProfile.json"))[this.brand][this.device];
        var buildtimeShared = require('./environment/buildtimeShared.js')[this.brand];
        if (this.domainOverride) {
          console.log("Domain Override found: ".concat(this.domainOverride));
          var _require2 = require('./consts'),
            DOMAIN_OVERRIDE = _require2.DOMAIN_OVERRIDE;
          var domainOverrideAppURL = DOMAIN_OVERRIDE[this.env][this.brand][this.domainOverride]['APP_URL'];
          if (domainOverrideAppURL) {
            console.log("Updating APP_BASE_URL: '".concat(buildtimeProfile.APP_BASE_URL, "' to '").concat(domainOverrideAppURL, "'"));
            buildtimeProfile.APP_BASE_URL = domainOverrideAppURL;
          }
        }
        var APP_BASE_URL = buildtimeProfile.APP_BASE_URL;
        var determinedProps = {
          CONFIG_LOCATION: APP_BASE_URL,
          ASSET_URL: "".concat(APP_BASE_URL, "/us/build"),
          IS_CORDOVA_APP: this.device === 'android' || this.device === 'ios'
        };
        // console.log({ ...buildtimeProfile, ...determinedProps, ...buildtimeShared, ...this.override });

        return _objectSpread({}, buildtimeProfile, {}, determinedProps, {}, buildtimeShared, {}, this.override);
      } catch (err) {
        throw new Error(err);
      }
    }
  }]);
  return Buildtime;
}();
var Runtime = /*#__PURE__*/function () {
  "use strict";

  function Runtime(_ref2) {
    var env = _ref2.env,
      state = _ref2.state,
      brand = _ref2.brand,
      _ref2$override = _ref2.override,
      override = _ref2$override === void 0 ? {} : _ref2$override;
    _classCallCheck(this, Runtime);
    this.env = env;
    this.state = state;
    this.brand = brand;
    this.override = override;
  }
  _createClass(Runtime, [{
    key: "profile",
    value: function profile() {
      if (!this.env || !this.state || !this.brand) {
        return new Error('Environment or State or Brand was not specified');
      }
      try {
        var envPath = "./environment/".concat(this.env);
        var envRuntimeProfile = this.buildEnvRuntimeProfile(envPath);
        var regionRuntimeProfile = require("".concat(envPath, "/runtimeProfiles/").concat(this.state, ".json"));
        var runtimeProfile = regionRuntimeProfile[this.brand] || regionRuntimeProfile;
        return _objectSpread({}, envRuntimeProfile, {}, runtimeProfile, {}, this.override);
      } catch (err) {
        console.error("\u2757Failed profile construction.  Environment: ".concat(this.env, ", Brand: ").concat(this.brand, ", Region: ").concat(this.state, ".\u2757"));
        throw err;
      }
    }
  }, {
    key: "buildEnvRuntimeProfile",
    value: function buildEnvRuntimeProfile() {
      var _this = this;
      var envProfile = envConfigs[this.env];
      return Object.keys(envProfile).reduce(function (builtProfile, envProfileKey) {
        var val = envProfile[envProfileKey];
        var country = CANADA_REGIONS.includes(_this.state) ? 'ca' : 'us';
        builtProfile[envProfileKey] = val instanceof Function ? val(_this.state, country, _this.brand) : val;
        return builtProfile;
      }, {});
    }
  }]);
  return Runtime;
}();
module.exports = {
  Buildtime: Buildtime,
  Runtime: Runtime,
  checkIfValid: function checkIfValid() {
    var regionList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var stateCodeReference = require('./environment/validRegionCodeList').getStateAbbreviations();
    regionList.forEach(function (state) {
      if (!stateCodeReference.hasOwnProperty(state.toUpperCase())) {
        throw new Error("Invalid Region Code Provided. Recieved '".concat(state.toUpperCase(), "'"));
      }
    });
    return regionList;
  },
  getAvailableRegions: function getAvailableRegions(brand, env, platform) {
    var availableRegions = require('./environment/availableStates.json')[brand][env][platform];
    if (!availableRegions) {
      throw new Error("".concat(brand, "-").concat(env, "-").concat(platform, " available states not found"));
    }
    return availableRegions;
  },
  getAppConfigs: function getAppConfigs(env) {
    var envAppConfigs = require('./environment/appConfigs.json')[env];
    var sharedAppConfigs = require('./environment/appConfigs.json')['shared'];
    if (!envAppConfigs) {
      throw new Error("".concat(env, " is invalid environment"));
    }
    return _objectSpread({}, sharedAppConfigs, {}, envAppConfigs);
  },
  getBrandSharedConfig: function getBrandSharedConfig(brand) {
    var brandShared = require('./environment/buildtimeShared.js')[brand];
    if (!brandShared) {
      throw new Error("".concat(brand, " is an invalid brand"));
    }
    ;
    return _objectSpread({}, brandShared);
  }
};